package kz.dentalcrm.app

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.WindowInsets
import androidx.compose.foundation.layout.asPaddingValues
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.statusBars
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.layout.windowInsetsPadding
import androidx.compose.foundation.layout.wrapContentWidth
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.SnackbarDuration
import androidx.compose.material3.SnackbarHost
import androidx.compose.material3.SnackbarHostState
import androidx.compose.material3.SnackbarResult
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.key
import androidx.compose.runtime.mutableIntStateOf
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import dentalcrm.composeapp.generated.resources.Res
import dentalcrm.composeapp.generated.resources.img_error
import dentalcrm.composeapp.generated.resources.img_success
import dentalcrm.composeapp.generated.resources.img_warning
import kotlinx.coroutines.launch
import kz.dentalcrm.app.core.network.LogoutEventBus
import kz.dentalcrm.app.di.apiServicesModule
import kz.dentalcrm.app.di.getStorage
import kz.dentalcrm.app.di.networkModule
import kz.dentalcrm.app.di.repositoryModule
import kz.dentalcrm.app.di.viewModelModules
import kz.dentalcrm.app.navigation.AppNavDisplay
import kz.dentalcrm.app.theme.AppTheme
import kz.dentalcrm.app.theme.DefaultTheme
import kz.dentalcrm.app.theme.ObserveLatestAsEvents
import kz.dentalcrm.app.theme.SnackbarController
import kz.dentalcrm.app.theme.SnackbarEvent
import org.jetbrains.compose.resources.painterResource
import org.koin.compose.KoinApplication

@Composable
internal fun App() = AppTheme {
    KoinApplication(
        application = {
            modules(
                getStorage(),
                networkModule(),
                apiServicesModule(),
                repositoryModule(),
                viewModelModules(),
                kz.dentalcrm.app.navigation.navigationModule
            )
        }
    ) {
        AppTheme {
            Box(
                modifier = Modifier.fillMaxSize()
            ) {
                val topInset = WindowInsets.statusBars.asPaddingValues().calculateTopPadding()
                var sessionKey by remember { mutableIntStateOf(0) }
                LaunchedEffect(Unit) {
                    LogoutEventBus.events.collect { sessionKey++ }
                }
                val snackbarHostState = remember { SnackbarHostState() }
                val scope = rememberCoroutineScope()
                var snackbarType by remember {
                    mutableStateOf<SnackbarEvent.SnackbarType>(
                        SnackbarEvent.SnackbarType.Green
                    )
                }
                ObserveLatestAsEvents(
                    flow = SnackbarController.events,
                    snackbarHostState
                ) { event ->
                    scope.launch {
                        snackbarHostState.currentSnackbarData?.dismiss()
                        snackbarType = event.snackbarType
                        val result = snackbarHostState.showSnackbar(
                            message = event.message,
                            actionLabel = event.action?.name,
                            duration = SnackbarDuration.Short
                        )

                        if (result == SnackbarResult.ActionPerformed) {
                            event.action?.action?.invoke()
                        }
                    }
                }
                key(sessionKey) {
                    AppNavDisplay()
                }
                SnackbarHost(
                    modifier = Modifier
                        .fillMaxWidth(),
                    hostState = snackbarHostState
                ) { snackbarData ->
                    Column(
                        modifier = Modifier
                            .fillMaxWidth()
                            .heightIn(),
                    ) {
                        Row(
                            modifier = Modifier
                                .windowInsetsPadding(WindowInsets.statusBars)
                                .fillMaxWidth()
                                .padding(horizontal = 56.dp, vertical = 4.dp)
                                .heightIn(min = 44.dp)
                                .background(
                                    color = DefaultTheme.colors.surfaceSecondary,
                                    shape = RoundedCornerShape(12.dp)
                                )
                                .clip(
                                    shape = RoundedCornerShape(12.dp)
                                ),
                            horizontalArrangement = Arrangement.Center,
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            Image(
                                modifier = Modifier.size(24.dp),
                                painter = painterResource(
                                    when (snackbarType) {
                                        SnackbarEvent.SnackbarType.Green -> Res.drawable.img_success
                                        SnackbarEvent.SnackbarType.Grey -> Res.drawable.img_warning
                                        else -> Res.drawable.img_error
                                    }
                                ),
                                contentDescription = null
                            )
                            Spacer(modifier = Modifier.width(12.dp))
                            Text(
                                modifier = Modifier.wrapContentWidth(),
                                textAlign = TextAlign.Start,
                                text = snackbarData.visuals.message,
                                maxLines = 2,
                                overflow = TextOverflow.Ellipsis,
                                color = DefaultTheme.colors.onSurface,
                                style = DefaultTheme.typography.bodySmallMedium
                            )
                        }
                    }
                }
            }
        }
    }
}
